import BalanceControlRenderer from './BalanceControlRenderer'
import _ from 'underscore'

function PtoControlRenderer () {}
PtoControlRenderer.prototype = _.create(BalanceControlRenderer.prototype);
PtoControlRenderer.prototype.cellGeneralClassName = "ptoControlCell";
PtoControlRenderer.prototype.getFlagValue = function( value ) {
    return value.pto;
};

export default PtoControlRenderer



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/PtoControlRenderer.js